<div id="rules" class="tab-pane fade in active">
    <div id="dropdowncopy" style="display: none;">
        <select class="form-control" id="Labels" name="Labels" style="width:100%!important;">
            <option value="">Choose Label</option>
        </select>
    </div>

    <!-- <h3 style="text-align:center;">Add New Rule</h3> -->
    <br />

    <div class="row">
        <div class="col-lg-6">
            <div class="inline">
                <div class="wrapmulti">
                    <p id="totalRecords">
                        <h3 style="font-size:14px;font-weight:normal!important;">Selected RuleID: </h3>

                        <span id="spanRuleMapping">
                            <select class="form-control" id="ruleMapping" name="ruleMapping"
                                style="width:100%!important;" [(ngModel)]="rule_MappingID"
                                (ngModelChange)="onRuleIDChange($event)">
                                <option value="">Choose RuleID</option>
                                <option *ngFor="let rule of rulesMapping" value="{{rule.RuleMappingID}}">
                                    {{rule.RuleId}}
                                </option>
                            </select>
                            <!-- @Html.DropDownList("category", ViewBag.Categories as SelectList, 
                             "Choose Category", new { @class = "form-control", @style = "width:100%!important;" }) -->
                        </span>
                        <!-- </p> -->
                        <!-- <p id="totalCategories" style="vertical-align:middle;"><br><br>
                        <span id="totalCategoriesValue"><button id="btnAdd_category" (click)="callRefresh()"
                            class="btn btn-sm btn-default buttonStyle2" style="margin-top:20px;">Refresh</button></span>
                    </p> -->

                </div>
            </div>
            <div class="inline" style="margin-left: 18.2%;">
                <button id="btnDeleteRule" (click)="deleteRule()" class="btn btn-default buttonStyle2"
                    style="width: 110px !important;padding-left: 20px !important;">Delete Rule</button>
            </div>

        </div>

        <div class="col-lg-4" style="float:right;">
            <button id="btnSendRules" (click)="AddNewRules()" type="button" class="btn btn-lg btn-primary buttonStyle"
                style="float:left;text-align:center;margin-left: 0px;margin-top: 15px;padding-left: 0px;"><span
                    class="fa fa-plus"></span> &nbsp;Reset Field </button>
            <!-- <h3 style="font-size:14px;font-weight:normal!important;">  Enter a rule name: </h3>
            <input id="ruleID" [(ngModel)]="rule_id" type="text" placeholder="Enter Rule Name" 
            style="padding:15px;width:75%;background-color:#F9f9f9 !important;border:none;" /> -->
        </div>


    </div>

    <div class="row">
        <div class="col-lg-4" style="float:left;">
            <h3 style="font-size:14px;font-weight:normal!important;"> Enter a rule name: </h3>
            <input id="ruleID" [(ngModel)]="rule_id" type="text" placeholder="Enter Rule Name"
                style="padding:15px;width:75%;background-color:#F9f9f9 !important;border:none;" />
        </div>
        <div class="col-lg-5">
            <div class="inline">
                <div class="wrapmulti">
                    <p id="totalRecords">
                        <h3 style="font-size:14px;font-weight:normal!important;">Selected Category: </h3>

                        <span id="totalRecordsValue">
                            <select class="form-control" id="category" name="category" style="width:100%!important;"
                                [(ngModel)]="rule_category" required>
                                <option value="">Choose Category</option>
                                <option *ngFor="let cat of categoryrules" value="{{cat.Category1}}">
                                    {{cat.Category1}}
                                </option>
                            </select>
                            <!-- @Html.DropDownList("category", ViewBag.Categories as SelectList, 
                                 "Choose Category", new { @class = "form-control", @style = "width:100%!important;" }) -->
                        </span>
                        <!-- </p> -->
                        <p id="totalCategories" style="vertical-align:middle;"><br><br>
                            <span id="totalCategoriesValue"><button id="btnAdd_category" (click)="callRefresh()"
                                    class="btn btn-sm btn-default buttonStyle2"
                                    style="margin-top:20px;">Refresh</button></span>
                        </p>

                </div>
            </div>


        </div>

    </div>
    <br />
    <br />
    <!--messages-->
    <p class="alert alert-danger" id="successMessage"  *ngIf = "result.RuleError !=null">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{result.RuleError}}
    </p>
    <p class="alert alert-success" id="successMessage"  *ngIf ="result.RuleSuccess != null">
        <i class="fa fa-check" aria-hidden="true"></i> {{result.RuleSuccess}}
    </p>
    <p class="alert alert-danger" id="successMessage"  *ngIf="isValidated==false">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ruleFormvalidationMessage}}
    </p>

    <!--Description-->
    <div class="row">
        <div class="col-md-6" style="margin-right: -73px;">
            <h3 style="font-size:14px;font-weight:normal!important;"> Description </h3>
            <textarea id="txtRulesXml" rows="5" cols="158" style="float: left;"
                [(ngModel)]="RulesDescription"></textarea>
        </div>
    </div>
    <!--Rules-->
    <div class="row">
        <div class="col-md-4">
            <h3 style="font-size:14px;font-weight:normal!important;"> Rule Xml </h3>
            <textarea id="txtRulesXml" rows="70" cols="158" style="float: left;max-height: 300px;"
                [(ngModel)]="RulesXml"></textarea>
            <!--Submit Button-->
            <button id="btnSendRules" (click)="SendRules()" type="button" class="btn btn-lg btn-primary buttonStyle"
                style="float:left;text-align:center;margin-left: 0px;margin-top: 15px;padding-left: 0px;">Submit</button>
        </div>
    </div>


</div>